import styled from 'styled-components';

export const StyledGroceryProductsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 0;
  padding: ${({ theme }) => `${theme.space[3]}px`};
  border-bottom: 1px solid ${props => props.theme.color.background};
  > div {
    margin-right: 4px;
    margin-left: 4px;
  }
`;
